/**
 * Liste des pays africains (codes ISO 3166-1 alpha-2).
 *
 * Source unique partagée entre la route /api/geo/country, le rendu serveur
 * de /pricing et create-payment-intent, qui refuse le tarif Afrique hors
 * d'Afrique (tarification Afrique). Ne pas dupliquer cette liste.
 */
export const AFRICA_COUNTRIES = [
    "DZ", // Algérie
    "AO", // Angola
    "BJ", // Bénin
    "BW", // Botswana
    "BF", // Burkina Faso
    "BI", // Burundi
    "CV", // Cap-Vert
    "CM", // Cameroun
    "CF", // Centrafrique
    "TD", // Tchad
    "KM", // Comores
    "CG", // Congo
    "CD", // RD Congo
    "CI", // Côte d'Ivoire
    "DJ", // Djibouti
    "EG", // Égypte
    "GQ", // Guinée équatoriale
    "ER", // Érythrée
    "SZ", // Eswatini
    "ET", // Éthiopie
    "GA", // Gabon
    "GM", // Gambie
    "GH", // Ghana
    "GN", // Guinée
    "GW", // Guinée-Bissau
    "KE", // Kenya
    "LS", // Lesotho
    "LR", // Liberia
    "LY", // Libye
    "MG", // Madagascar
    "MW", // Malawi
    "ML", // Mali
    "MR", // Mauritanie
    "MU", // Maurice
    "MA", // Maroc
    "MZ", // Mozambique
    "NA", // Namibie
    "NE", // Niger
    "NG", // Nigeria
    "RW", // Rwanda
    "ST", // Sao Tomé-et-Príncipe
    "SN", // Sénégal
    "SC", // Seychelles
    "SL", // Sierra Leone
    "SO", // Somalie
    "ZA", // Afrique du Sud
    "SS", // Soudan du Sud
    "SD", // Soudan
    "TZ", // Tanzanie
    "TG", // Togo
    "TN", // Tunisie
    "UG", // Ouganda
    "ZM", // Zambie
    "ZW", // Zimbabwe
];

/**
 * Offres du tunnel réservées à l'Afrique, avec l'offre standard équivalente
 * pour qui les ouvre d'ailleurs (lien partagé, URL modifiée à la main).
 */
export const AFRICA_CHECKOUT_FALLBACK = {
    "africa-committed": "annually",
    "africa-monthly": "monthly",
};

export function isAfricaCheckoutType(type) {
    return Object.prototype.hasOwnProperty.call(AFRICA_CHECKOUT_FALLBACK, type);
}
